import { BaseEntity } from './base-entity';

export class Faculty implements BaseEntity {
    public static MAX_LOGO_SIZE_KB = 800;
    public static MIM_LOGO_WIDTH = 100;
    public static MIM_LOGO_HEIGHT = 100;

    constructor(public id?: number,
                public name?: string,
                public logoContentType?: string,
                public logo?: any) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/faculty.model.ts